export type Attributes = Record<string, unknown>
export type Jsonb = Record<string, unknown>

export type TabTypes = 'Overview' | 'Quality' | 'ESG Metrics'

export interface ClientOptions {
  params?: any
  headers?: Record<string, string>
  json?: any
  body?: any
  method?: 'POST' | 'GET' | 'PUT' | 'DELETE' | 'PATCH' | 'OPTIONS' | 'HEAD'
  skipError?: boolean
  form?: any
}

// TODO: update with mockdata
export interface AssetEvent {
  asset: string
  assetPath: string
  comment: string
  deviceId: string
  enqueuedTimeUtc: string
  eventType: string
  has_outer_diameter: boolean
  has_ovality: boolean
  has_periodic: boolean
  has_wall_thickness: boolean
  measurement_max: number
  measurement_min: number
  outer_diameter_max: number
  outer_diameter_min: number
  ovality_max: number
  ovality_min: number
  PartitionKey: string
  recipe: string
  RowKey: string
  standard: string
  startTime: string
  stopTime: string
  throughput_points: number | string
  Timestamp: string
  uuid: string
  "odata.etag"?: string
  "throughput_points@odata.type"?: string
  ledgerHash?: string
  ts?: string
}

export enum MeasurementStatus {
  Passed = 'passed',
  Failed = 'failed',
}

export interface MeasurementRecord {
  "odata.etag": string
  deviceId: string
  enqueuedTimeUtc: string
  measurement: string
  PartitionKey: string
  rawJson: string
  RowKey: string
  status: MeasurementStatus
  Timestamp: string
  ts: string
  distance: number
  value: number | string
  "value@odata.type"?: string
}

export interface Datapoint {
  x: number | string
  y: number
}

export interface Dataset {
  label: string
  data: Datapoint[] | number[]
  backgroundColor?: string
  barPercentage?: number
  borderColor?: string
  categoryPercentage?: number
  fill?: boolean | string
  pointBackgroundColor?: string
  pointHitRadius?: number
  pointHoverRadius?: number
  pointRadius?: number
  pointStyle?: boolean
  showLine?: boolean
  tension?: number
}
